import { FC } from 'react';
import { Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

interface LastActivityInfoProps {
  lastUpdate: string | null;
}

/**
 * Component to display the user's last activity timestamp
 */
export const LastActivityInfo: FC<LastActivityInfoProps> = ({ lastUpdate }) => {
  const { i18n, t } = useTranslation();
  
  if (!lastUpdate) {
    return null;
  }
  
  const lastUpdateDate = new Date(lastUpdate);
  
  // Get the appropriate locale for date-fns based on current language
  const getDateFnsLocale = () => {
    switch (i18n.language) {
      case 'fr':
        return fr;
      case 'en':
      default:
        return enUS;
    }
  };
  
  const timeAgo = formatDistanceToNow(lastUpdateDate, { 
    addSuffix: true,
    locale: getDateFnsLocale()
  });
  
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500 mt-2">
      <Clock className="h-4 w-4 text-gebeya-pink" />
      <span>{t('profile.lastActive')} {timeAgo}</span>
    </div>
  );
}; 